import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

import * as fromSettingsWorkflowsState from '@app/store/state/settings/workflows/workflows.state';
import * as fromSettingsWorkflowsActions from '@app/store/state/settings/workflows/workflows.actions';

import * as Objects from '@core/objects';



@Injectable({
    providedIn: 'root'
})
export class SettingsWorkflowsService {

    constructor(private store: Store<fromSettingsWorkflowsState.SettingsWorkflows>) {}
    
    // state actions
    loadWorkflows = () => this.store.dispatch( new fromSettingsWorkflowsActions.LoadWorkflows());

    loadWorkflowTransitions = (workflowId: number) => this.store.dispatch( new fromSettingsWorkflowsActions.LoadTransitions(workflowId));

    cleanEditor = () => this.store.dispatch( new fromSettingsWorkflowsActions.ClearWorkflowEditor());

    saveWorkflowTransitions = (transitions,  workflowId: number) => 
            this.store.dispatch( new fromSettingsWorkflowsActions.SaveTransitions(transitions,workflowId));
    // TODO: include activation and deactivation actions:
    // TODO: include add workflow action

    // state selectors
    selectWorkflows = (): Observable<Objects.Workflow[]>  => this.store.select(fromSettingsWorkflowsState.settingsWorkflowsSelector);
    
    selectTransitions = (): Observable<Objects.WorkflowTransition[]>  => this.store.select(fromSettingsWorkflowsState.transitionsSelector);
    
    selectInitialized = (): Observable<any>  => this.store.select(fromSettingsWorkflowsState.initializedSelector);

    selectError = (key: string): Observable<HttpErrorResponse> => this.store.select(fromSettingsWorkflowsState.errorSelector(key));

}
